import {
  createContext,
  useContext,
  type JSX,
  createSignal,
  type Accessor,
  type Setter
} from 'solid-js'
import { type Paddle } from '@paddle/paddle-js'
import {
  createPaddleLoader,
  type EnsurePaddle,
  loadPaddle,
  PADDLE_RETRY_POLICY
} from '../helpers/paddle-loader'

interface PaddleContextType {
  readonly paddle: Accessor<Paddle | undefined>
  readonly setPaddle: Setter<Paddle | undefined>
  readonly ensurePaddle: EnsurePaddle
}

const [paddle, setPaddle] = createSignal<Paddle | undefined>()

const ensureLoaded = createPaddleLoader(async () => await loadPaddle(PADDLE_RETRY_POLICY))

const ensurePaddle: EnsurePaddle = async (options) => {
  const instance = await ensureLoaded(options)
  setPaddle(instance)
  return instance
}

const defaultContextValue: PaddleContextType = {
  paddle,
  setPaddle,
  ensurePaddle
}

const PaddleContext = createContext<PaddleContextType>(defaultContextValue)

export const PaddleProvider = (props: { children: JSX.Element }): JSX.Element => {
  return (
    <PaddleContext.Provider value={defaultContextValue}>
      {props.children}
    </PaddleContext.Provider>
  )
}

export const usePaddle = (): PaddleContextType => {
  return useContext(PaddleContext)
}
